<template>
    <div class="">
        <div class="mb-4">
            <span class="text-sm font-bold text-gray-500">02.</span>
        </div>
        <div class="mb-4">
            <span class="text-5xl font-extrabold tracking-tight">Zijpanelen.</span>
        </div>
        <div class="mb-4">
            <span class="text-xl font-extrabold tracking-tight">Positie</span>
        </div>
        <div class="grid grid-cols-2 gap-2 mb-8">
            <button
                class="inline-flex items-center justify-center px-4 py-2 text-black transition duration-500 ease-in-out border cursor-pointer hover:bg-black hover:text-white"
                :class="sidePanelAmount === 'none' ? ['bg-vida-dark', 'text-white'] : 'bg-gray-100'"
                @click="setSidePanelAmount()"
                id="none"
            >
                <i class="w-4 h-4 mr-2 far fa-times-circle"></i>
                <span>Geen</span>
            </button>
            <button
                class="inline-flex items-center justify-center px-4 py-2 text-black transition duration-500 ease-in-out border cursor-pointer hover:bg-black hover:text-white"
                :class="sidePanelAmount === 'left' ? ['bg-vida-dark', 'text-white'] : 'bg-gray-100'"
                @click="setSidePanelAmount()"
                id="left"
            >
                <i class="w-4 h-4 mr-2 far fa-arrow-alt-from-left"></i>
                <span>Links</span>
            </button>
            <button
                class="inline-flex items-center justify-center px-4 py-2 text-black transition duration-500 ease-in-out border cursor-pointer hover:bg-black hover:text-white"
                :class="sidePanelAmount === 'right' ? ['bg-vida-dark', 'text-white'] : 'bg-gray-100'"
                @click="setSidePanelAmount()"
                id="right"
            >
                <i class="w-4 h-4 mr-2 far fa-arrow-alt-from-right"></i>
                <span>Rechts</span>
            </button>
            <button
                class="inline-flex items-center justify-center px-4 py-2 text-black transition duration-500 ease-in-out border cursor-pointer hover:bg-black hover:text-white"
                :class="sidePanelAmount === 'both' ? ['bg-vida-dark', 'text-white'] : 'bg-gray-100'"
                @click="setSidePanelAmount()"
                id="both"
            >
                <i class="w-4 h-4 mr-2 far fa-arrows-alt-h"></i>
                <span>Beiden</span>
            </button>
        </div>
        <div class="mb-4">
            <span class="text-xl font-extrabold tracking-tight">Afmetingen</span>
        </div>
        <div class="ml-4">
            <div class="mb-4">
                <label class="text-sm font-bold text-gray-500">Breedte <span class="text-xs text-gray-400">(max. {{ sidePanelWidthMax }} cm.)</span></label>
                <div class="inline-flex items-center w-full mt-2 border">
                    <div class="w-12 py-2 text-center bg-gray-100">
                        <i class="w-6 text-gray-500 far fa-ruler-horizontal"></i>
                    </div>
                    <input 
                        class="w-full p-2 focus:outline-none focus:text-black"
                        :class="sidePanelAmount === 'none' ? ['bg-gray-100', 'text-gray-300', 'cursor-not-allowed'] : ['']"
                        id="side-panel-width" 
                        v-model.lazy="sidePanelWidthInput" 
                        type="number" 
                        placeholder="Breedte"
                        :min="this.sidePanelWidthMin"
                        :max="this.sidePanelWidthMax"
                        :disabled="sidePanelAmount === 'none'"
                    >
                    <div class="w-12 py-2 text-center bg-gray-100">
                        <span class="text-sm text-gray-500">cm.</span>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { mapMutations } from 'vuex'

    export default {
        name: "Form",
        components: {

        },
        data() {
            return {

            }
        },
        methods: {
            ...mapMutations([
                'setSidePanelAmount',
                'setSidePanelBeamAmount',
                'setSidePanelUprightAmount',
                'setSidePanelWidth'
            ]),
        },
        computed: {
            ...mapState([
                'sidePanelAmount',
                'sidePanelUprightAmount',
                'sidePanelBeamAmount',
                'sidePanelDivision',
                'sidePanelWidthMin',
                'sidePanelWidthMax'
            ]),
            sidePanelWidthInput: {
                get () {
                    return this.$store.state.sidePanelWidth
                },
                set (value) {
                    this.$store.commit('setSidePanelWidth', value)
                }
            }
        },
        watch: {
            sidePanelWidthInput() {
                if (this.$store.state.sidePanelWidth > this.sidePanelWidthMax) { 
                    this.setSidePanelWidth(this.sidePanelWidthMax)
                }
                else if (this.$store.state.sidePanelWidth < this.sidePanelWidthMin) {
                    this.setSidePanelWidth(this.sidePanelWidthMin)
                }
            }
        }
    }
</script>

<style>

</style>